<template>
  <div class="calculator">
    <calculator />
    <div class="login-link">
      <h1>
        Gesuch erfassen
      </h1>
      <p>
        <router-link to="/">Zum Login</router-link>
      </p>
    </div>
  </div>
</template>

<script>
  import Calculator from '@/components/calculator/Calculator.vue'
  export default {
    components: {
      Calculator
    }
  }
</script>

<style lang="scss">
  .calculator{
    padding: 2rem 0;
    text-align: left;
  }
  .login-link{
    text-align: center;
    margin-top: 2.5rem;
  }
</style>
